import React from "react";
import { CategoryListScreenContext } from "./context";

export const useCategoryListScreen = () => {
  const context = React.useContext(CategoryListScreenContext);

  if (!context)
    throw new Error(
      "useCategoryListScreen must be used within a CategoryListScreen Provider"
    );

  return context;
};
